import { useParams } from "react-router";
import { IoFolder } from "react-icons/io5";
import { BiDuplicate } from "react-icons/bi";
import { CiMenuKebab } from "react-icons/ci";
import { LuFolderPlus } from "react-icons/lu";
import { MdContentCopy } from "react-icons/md";
import { useEffect, useRef, useState } from "react";
import { Collapse, ListGroup } from "react-bootstrap";
import { BsFillFileEarmarkZipFill } from "react-icons/bs";
import { FaFolder, FaTrashAlt, FaEdit } from "react-icons/fa";
import { IoIosArrowDown, IoIosArrowUp, IoIosMove } from "react-icons/io";
import { NoDataFoundTable, PageLoader } from "../../Components/NoDataFoundTable/NoDataFoundTable";
import { editorS3FileManagerServices } from "../../APIServices/Editor/editorS3FileManagerServices";
import Swal from "sweetalert2";
import UseToggle from "../../Hooks/UseToggle";
import MoveFolder from "./FileManagement/MoveFolder";
import CopyFolder from "./FileManagement/CopyFolder";
import AddNewFolder from "./FileManagement/AddNewFolder";
import UpdateFolder from "./FileManagement/UpdateFolder";
import DuplicateFolder from "./FileManagement/DuplicateFolder";
import GenerateZipFile from "./FileManagement/GenerateZipFile";

function FileManagementSidebar({
  openModule,
  handleAddNewTab,
  collapseSidebar,
  handleDeleteTab,
  fileFolderUpdater,
  checkActiveTabData,
  setFileFolderUpdater,
}) {
  const toggles = UseToggle();
  const AppsRef = useRef(null);
  const { studyId } = useParams()
  const [loader, setLoader] = useState(false);
  const [folderData, setFolderData] = useState("");
  const [activeMenu, setActiveMenu] = useState("");
  const [fileManager, setFileManager] = useState([]);

  let objectIds = checkActiveTabData("fileManagement")?.ids || checkActiveTabData("fileManagementRecycleBin")

  const [openFolders, setOpenFolders] = useState({});

  const toggleFolder = (folderId) => {
    setOpenFolders(prev => ({ ...prev, [folderId]: !prev[folderId] }));
  };

  const getS3EditorFolders = async () => {
    setLoader(true);
    let data = await editorS3FileManagerServices.getS3EditorFolders(studyId, "root", "", "", "folder");
    setFileManager(data?.data || []);
    setLoader(false);
  };

  const softDeleteS3EditorFolder = async (path) => {
    Swal.fire({
      icon: "warning",
      title: "Are you sure?",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonColor: "#103C5E",
      confirmButtonText: `Yes, Delete it!`,
      text: `You want to Delete this folder!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.path = [path];
        userData.type = "delete";
        userData.studyId = studyId;
        let data = await editorS3FileManagerServices.softDeleteS3EditorFolder(userData);
        if (data?.statusCode === 200) {
          if (objectIds?.fullPath === path) {
            handleDeleteTab("fileManagement")
          }
          setFileFolderUpdater(Math.floor(1000000000 + Math.random() * 9000000000))
        }
      }
    });
  };

  useEffect(() => {
    getS3EditorFolders();
  }, [openModule, fileFolderUpdater]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (AppsRef.current && !AppsRef.current.contains(event.target) && !event.target.closest(".node-menu") && !event.target.closest(".kebab-icon")) {
        setActiveMenu("");
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => document.removeEventListener("click", handleClickOutside, true);
  }, []);

  return (
    <>
      <ListGroup.Item className="border-0 border-bottom bg-light" style={{ padding: "6px 10px" }} ref={AppsRef}>
        <div className="hstack justify-content-between w-100">
          <span
            onClick={() => handleAddNewTab(`File Management`, "fa-solid fa-desktop", `fileManagement`, {})}
            className="fw-bold CP">
            <i className="fa-solid fa-desktop me-2"></i>
            {!collapseSidebar && <span>File Management</span>}
          </span>
          {!collapseSidebar &&
            <span className="fw-bold">
              <LuFolderPlus onClick={() => { toggles.setToggle(); setFolderData("") }} className="me-2 CP" style={{ fontSize: 16 }} />
            </span>
          }
        </div>
      </ListGroup.Item>

      <ListGroup className="rounded-0 overflow-auto" style={{ height: "calc(100vh - 175px)" }}>
        {loader ? (
          <PageLoader />
        ) : fileManager?.length === 0 ? (
          !collapseSidebar &&
          <NoDataFoundTable MSG={"Folder not found!"} />
        ) : (
          fileManager?.map((node) =>
            <TreeNode
              node={node}
              toggles={toggles}
              key={node.fullPath}
              objectIds={objectIds}
              folderData={folderData}
              activeMenu={activeMenu}
              openFolders={openFolders}
              toggleFolder={toggleFolder}
              setFolderData={setFolderData}
              setActiveMenu={setActiveMenu}
              collapseSidebar={collapseSidebar}
              handleAddNewTab={handleAddNewTab}
              softDeleteS3EditorFolder={softDeleteS3EditorFolder}
            />)
        )}
      </ListGroup>
      <ListGroup.Item className={`border-0 border-top ${objectIds?.studyTabId === "fileManagementRecycleBin" ? "bg-danger text-white" : "bg-danger-subtle"} CP`} title="Recycle Bin" style={{ padding: "6px 10px" }} ref={AppsRef}>
        <div className="hstack justify-content-between w-100">
          <span className="fw-bold"
            onClick={() => handleAddNewTab(`Recycle Bin`,
              "fa-solid fa-trash-alt",
              `fileManagementRecycleBin`
            )}
          >
            <i className={`fa-solid fa-trash-alt me-2 ${objectIds?.studyTabId === "fileManagementRecycleBin" && "text-white"}`}></i>
            {!collapseSidebar && <span>Recycle Bin</span>}
          </span>
        </div>
      </ListGroup.Item>
      <AddNewFolder
        Title="Add New Folder"
        Show={!toggles.toggle}
        folderData={folderData}
        Hide={toggles.setToggle}
        setFileFolderUpdater={setFileFolderUpdater}
      />
      <UpdateFolder
        folderData={folderData}
        Show={!toggles.toggle1}
        Hide={toggles.setToggle1}
        handleAddNewTab={handleAddNewTab}
        sourceKey={[folderData?.fullPath]}
        Title={`Update ${folderData?.name} Folder`}
        setFileFolderUpdater={setFileFolderUpdater}
      />
      <CopyFolder
        Show={!toggles.toggle2}
        Hide={toggles.setToggle2}
        sourceKey={[folderData?.fullPath]}
        setFileFolderUpdater={setFileFolderUpdater}
        Title={`Copy ${folderData?.name} in Other Folder`}
      />
      <MoveFolder
        Show={!toggles.toggle3}
        folderData={folderData}
        Hide={toggles.setToggle3}
        handleAddNewTab={handleAddNewTab}
        sourceKey={[folderData?.fullPath]}
        Title={`Move ${folderData?.name} Folder`}
        setFileFolderUpdater={setFileFolderUpdater}
      />
      <DuplicateFolder
        Show={!toggles.toggle4}
        Hide={toggles.setToggle4}
        sourceKey={[folderData?.fullPath]}
        setFileFolderUpdater={setFileFolderUpdater}
        Title={`Duplicate ${folderData?.name} Folder`}
      />
      <GenerateZipFile
        Show={!toggles.toggle5}
        Hide={toggles.setToggle5}
        setFileFolderUpdater={setFileFolderUpdater}
        Title={`Generate ${folderData?.name} Zip`}
        sourceKey={[folderData?.fullPath]}
      />
    </>
  );
}

function TreeNode({
  node,
  toggles,
  depth = 0,
  objectIds,
  folderData,
  activeMenu,
  openFolders,
  toggleFolder,
  setFolderData,
  setActiveMenu,
  collapseSidebar,
  handleAddNewTab,
  softDeleteS3EditorFolder,
}) {
  const isFolder = !node.isFile && node.children?.length > 0;
  const isOpen = openFolders[node.fullPath] || false;
  return (
    <>
      <ListGroup.Item
        action
        title={node?.sizeMB}
        className={`border-0 border-bottom hstack justify-content-between rounded-0 w-100 ${objectIds?.fullPath === node?.fullPath ? "selectedMenu" : isOpen ? "bg-light" : ""}`}
        style={{ paddingLeft: !collapseSidebar ? depth + 16 : 16, paddingTop: 5, paddingBottom: 5 }}
      >
        <div
          className="d-flex align-items-center flex-grow-1"
          onClick={() => {
            if (!node.isFile) {
              toggleFolder(node.fullPath);
              handleAddNewTab(`
                File Management`,
                "fa-solid fa-desktop",
                `fileManagement`,
                node
              )
            }
          }}
        >
          {node?.name === "Uncategories" ? <IoFolder className="me-1 text-info" /> : <FaFolder className="me-1 text-warning" />}
          {!collapseSidebar &&
            <span>{node.name}</span>
          }
        </div>
        {!collapseSidebar &&
          <>
            <div className="hstack gap-2">
              {isFolder && (isOpen ? <IoIosArrowUp /> : <IoIosArrowDown />)}
              <div
                className="kebab-icon"
                onClick={(e) => {
                  e.stopPropagation();
                  setActiveMenu(activeMenu === node.fullPath ? "" : node.fullPath);
                }}
              >
                <CiMenuKebab />
              </div>
            </div>
            <Collapse in={activeMenu === node.fullPath}>
              <div
                className="position-absolute z-1 node-menu"
                style={{ top: 34, right: 0 }}
                onClick={(e) => e.stopPropagation()}
              >
                <NodeActions
                  node={node}
                  toggles={toggles}
                  folderData={folderData}
                  setFolderData={setFolderData}
                  softDeleteS3EditorFolder={softDeleteS3EditorFolder}
                />
              </div>
            </Collapse>
          </>
        }
      </ListGroup.Item>
      {isFolder && (
        <Collapse in={isOpen}>
          <ListGroup>
            {node.children?.map((child) => (
              <TreeNode
                node={child}
                key={child.name}
                toggles={toggles}
                depth={depth + 16}
                objectIds={objectIds}
                folderData={folderData}
                activeMenu={activeMenu}
                openFolders={openFolders}
                toggleFolder={toggleFolder}
                setFolderData={setFolderData}
                setActiveMenu={setActiveMenu}
                collapseSidebar={collapseSidebar}
                handleAddNewTab={handleAddNewTab}
                softDeleteS3EditorFolder={softDeleteS3EditorFolder}
              />
            ))}
          </ListGroup>
        </Collapse>
      )}
    </>
  );
}

function NodeActions({
  node,
  toggles,
  setFolderData,
  softDeleteS3EditorFolder
}) {
  return (
    <ListGroup className="br3 small">
      {!node?.uniqueKey &&
        <>
          <ListGroup.Item
            action
            className="text-primary py-1 px-3 fontSize12 text-nowrap"
            onClick={(e) => { setFolderData(node); toggles.setToggle(); }}
          >
            <FaFolder className="me-1" /> Add New Folder
          </ListGroup.Item>
          <ListGroup.Item
            action
            className="text-primary py-1 px-3 fontSize12 text-nowrap"
            onClick={(e) => { setFolderData(node); toggles.setToggle1(); }}
          >
            <FaEdit style={{ marginLeft: -1 }} className="me-1" /> Rename Folder
          </ListGroup.Item>
          <ListGroup.Item
            action
            className="text-primary py-1 px-3 fontSize12 text-nowrap"
            onClick={(e) => { setFolderData(node); toggles.setToggle2(); }}
          >
            <MdContentCopy style={{ marginLeft: -1 }} className="me-1" /> Copy Folder
          </ListGroup.Item>
          <ListGroup.Item
            action
            className="text-primary py-1 px-3 fontSize12 text-nowrap"
            onClick={(e) => { setFolderData(node); toggles.setToggle3() }}
          >
            <IoIosMove style={{ marginLeft: -1 }} className="me-1" /> Move Folder
          </ListGroup.Item>
        </>
      }
      <ListGroup.Item
        action
        className="text-primary py-1 px-3 fontSize12 text-nowrap"
        onClick={(e) => { setFolderData(node); toggles.setToggle4(); }}
      >
        <BiDuplicate style={{ marginLeft: -1 }} className="me-1" /> Duplicate Folder
      </ListGroup.Item>
      <ListGroup.Item
        action
        onClick={(e) => {
          setFolderData(node);
          toggles.setToggle5();
        }}
        className="text-primary py-1 px-3 fontSize12 text-nowrap"
      >
        <BsFillFileEarmarkZipFill style={{ marginLeft: -1 }} className="me-1" /> Generate Zip
      </ListGroup.Item>
      {!node?.uniqueKey &&
        <ListGroup.Item
          action
          className="text-danger py-1 px-3 fontSize12 text-nowrap"
          onClick={() => softDeleteS3EditorFolder(node?.fullPath)}
        >
          <FaTrashAlt style={{ marginLeft: -1 }} className="me-1" /> Delete Folder
        </ListGroup.Item>
      }
    </ListGroup>
  );
}

export default FileManagementSidebar;
